export const emailIpWarmingAppGroupIdRequiredEmailTemplates =
  "/email/ip_warming/:app_group_id/required_email_templates";
